import { render, staticRenderFns } from "./CpttAdd.vue?vue&type=template&id=84dcabfe&scoped=true&"
import script from "./CpttAdd.vue?vue&type=script&lang=js&"
export * from "./CpttAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dcabfe",
  null
  
)

export default component.exports